export default __webpack_public_path__ + "static/media/IconTwitter.adab749e.svg";